export default "__VITE_ASSET__DcIKOtGk__"